import React, { memo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import SuccessActionIcon from './SuccessActionIcon';
import { SIDEBAR_ACTIONS } from '../../../../../../constants/actionsConstants';

const SendPaymentLinksAction = ({
  order,
  platform,
  onSendPaymentLink,
  closeParentModal
}) => {
  const { t } = useTranslation('Orders');
  const dispatch = useDispatch();

  const openModal = useCallback(() => {
    dispatch({
      type: SIDEBAR_ACTIONS.OPEN_SIDEBAR,
      payload: {
        componentKey: 'SendPaymentLinksModal',
        props: {
          order,
          platform,
          onSendPaymentLink
        }
      }
    });

    closeParentModal();
  }, [closeParentModal, dispatch, onSendPaymentLink, order, platform]);

  return (
    <div className="tw-flex tw-flex-col tw-items-center">
      <SuccessActionIcon
        icon="link-2-outline"
        title={t('orderSaved.copyLink')}
        subtitle={t('orderSaved.payment')}
        onClick={openModal}
      />
    </div>
  );
};

export default memo(SendPaymentLinksAction);
